import { RemExpertResultatSalarie } from "components/app/Api/ResultatRemExpertSalarieProvider";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { AppContext } from "components/app/RemExprertProvider";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import RemExpressContratFacProModal from "pages/audit rémunération/contratfacultatifpro pager";
import React, { useContext, useState } from "react";
import { FaGlobe, FaUser, FaBuilding, FaMoneyBillWave, FaUserTie, FaHandHoldingUsd, FaFileInvoiceDollar } from "react-icons/fa";
import CompactFinancialCard, { CompactFinancialContainer, FINANCIAL_THEMES } from "./CompactFinancialCard";

function RemExpressRemunerationSalarie(props) {
  let { Resultat, Prenom, ClientConjoint } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const ResultatSalarie = useContext(RemExpertResultatSalarie);
  const [modalContrat, setModalContrat] = useState(false);

  return (
    <>
      <CompactFinancialContainer
        title="Rémunération Salarié"
        subtitle={`Détail de la rémunération ${Prenom}`}
      >        <CompactFinancialCard
          icon={<FaUser />}
          title={`Budget rémunération ${Prenom}`}
          value={context.state.RemExpressCoutRemuneration}
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("cout_remuneration", "RemExpressCoutRemuneration", ResultatTNS, e)}
          theme={FINANCIAL_THEMES.success}
        />

        <CompactFinancialCard
          icon={<FaBuilding />}
          title="Cotisations patronales"
          value={applyFormat(context.state.RemExpressCotisationsPatronale, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => setModalContrat(true)}
          theme={FINANCIAL_THEMES.danger}
        />

        <CompactFinancialCard
          icon={<FaMoneyBillWave />}
          title="Salaire brut"
          value={context.state.RemExpressRemBrute}
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("salaire_brut", "RemExpressRemBrute", ResultatTNS, e)}
          theme={FINANCIAL_THEMES.orange}
        />

        <CompactFinancialCard
          icon={<FaUserTie />}
          title="Cotisations salariales"
          value={applyFormat(context.state.RemExpressCotisationsSalariale, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          theme={FINANCIAL_THEMES.orange}
        />

        <CompactFinancialCard
          icon={<FaHandHoldingUsd />}
          title="Salaire net"
          value={context.state.RemExpressRemNette}
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("salaire_net", "RemExpressRemNette", ResultatTNS, e)}
          theme={FINANCIAL_THEMES.primary}
        />

        <CompactFinancialCard
          icon={<FaFileInvoiceDollar />}
          title="Salaire imposable"
          value={context.state.RemExpressRemImposable}
          isEditable={true}
          onChange={(e) => context.handleCalculRemExpress("brut_imposable", "RemExpressRemImposable", ResultatTNS, e)}
          theme={FINANCIAL_THEMES.primary}
        />
      </CompactFinancialContainer>
        <Modal
          width="80%"
          height="82%"
          title="Situation professionnelle"
          icon={<FaGlobe />}
          visible={modalContrat}
          onClose={() => {
            context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "",  ResultatTNS, "");
            setModalContrat(false);
          }}
        >
          <RemExpressContratFacProModal
            Outil=""
            ClientConjoint={''}
            visible={modalContrat}
            onClose={() => {
              context.handleCalculRemExpress(context.state.RemExpressTypeCalcul, "", ResultatTNS, "");
              setModalContrat(false);            }}
          />
        </Modal>

    </>
  );
}
export default RemExpressRemunerationSalarie;
